if (document.readyState !== 'loading') {
    initOtpPopup();
} else {
    document.addEventListener('DOMContentLoaded', initOtpPopup);
}

document.querySelectorAll('.otp-login-popup-section .popup-close-icon')?.forEach(closeIcon => closeIcon.addEventListener('click', (e) => {
    const popupSection = closeIcon.closest('.otp-login-popup-section');
    if (popupSection && popupSection.hasAttribute('popup-type')) {
        const popupType = popupSection.getAttribute('popup-type');
        closeOtpLoginPopup(popupType);
    }
}));

function initOtpPopup() {
    // Init overlay
    document.querySelectorAll('.otp-login-popup-section .overlay')
        ?.forEach((popupOverlay) => {
            popupOverlay.addEventListener('click', function () {
                popupOverlay.closest('.otp-login-popup-section').classList.add('hidden');
                enableScroll();
                clearPopupInputs();
            });
        });
    // Init login buttons
    document.querySelectorAll('.boa-account-button').forEach((button) => {
        button.addEventListener('click', onAccountButtonClick);
    });
}

function disableScroll() {
    document.body.style.overflow = 'hidden';
};
function enableScroll() {
    document.body.style.overflow = 'auto';
};

/**
 * @param {'verify-customer-id' | 'otp-code' | 'phone-register' | 'shopify-register'} popupType
 */
function openOtpLoginPopup(event, popupType) {
    event?.preventDefault();
    const otpLoginPopupSection = document.querySelector(
        `.otp-login-popup-section[popup-type="${popupType}"]`
    );
    otpLoginPopupSection.classList.remove('hidden');
    disableScroll();
};

function closeOtpLoginPopup(popupType, keepScrollDisabled = false) {
    const otpLoginPopupSection = document.querySelector(`.otp-login-popup-section[popup-type="${popupType}"]`);
    otpLoginPopupSection.classList.add('hidden');
    clearPopupInputs();
    !keepScrollDisabled && enableScroll();
};

function clearPopupInputs() {
    document.querySelectorAll('.otp-login-popup-section')?.forEach((element) => {
        const inputs = element.querySelectorAll('input');
        inputs.forEach((input) => (input.value = ''));
    });
}

function toggleLoadingBtn(popupType) {
    const button = document.querySelector(`[popup-type=${popupType}] .loading-spinner`);
    const textButton = document.querySelector(
        `[popup-type=${popupType}] .otp-login-text-submit-btn`
    );
    textButton.classList.toggle('hidden');
    button.classList.toggle('hidden');
};

function translateInputError(popupType) {
    const inputs = document.querySelectorAll(
        `.otp-login-popup-section[popup-type="${popupType}"] input`
    );

    for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];
        const validity = input.validity;
        if (validity.valueMissing) {
            input.setCustomValidity(input.getAttribute('requiredmessage'));
            return;
        }
        if (validity.patternMismatch || validity.tooShort || validity.typeMismatch) {
            input.setCustomValidity(input.getAttribute('formatmessage'));
            return;
        }
        input.setCustomValidity('');
    }
};

function handleCartLogin(e) {
    console.log({ e })
    e.preventDefault();
    const minicart = document.getElementById('mini-cart')
    console.log(minicart)
    document.getElementById('mini-cart').open = false;
    openOtpLoginPopup(e, 'register-popup-id');
}